import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  getTextFilterCfg,
  getEditIconColumn,
  getSelectFilterCfg,
  getBooleanFormatter,
  getBooleanSelectFilterCfg
} from '../grid/ColumnHelpers'

import {guiSet} from '../../actions/uiActions'

import Grid from '../grid/Grid'
import { 
    virszemesRisksUnIznemumsDoubleSelected, 
    virszemesRisksUnIznemumsSelected 
} from '../../actions/riskiUnIznemumiActions';

const editIconColumn = getEditIconColumn((row) => (
    {
        type: `loc_virszemes_risks_un_iznemumi_ieraksts`,
        payload: {
            id: row.id,
            kods: row.uo_kods
        }
    }
))

class VirszemesRiskiUnIznemumiSaraksts extends Component {

    rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            this.props.virszemesRisksUnIznemumsDoubleSelected(row)
        }
    }

    render() {
        const getColumns = ({kodif}) => {
            return [editIconColumn, {
                dataField: 'uo_kods',
                text: 'ŪO kods',
                filterCfg: getTextFilterCfg(),
                width: 100
            }, {
                dataField: 'uo_nosaukums',
                text: 'Ūdens objekts',
                filterCfg: getTextFilterCfg(),
                width: 200
            }, {
                dataField: 'gads',
                text: 'Riska izvērtējuma gads',
                filterCfg: {
                    type: 'autocomplete',
                    autocompleteCfg: {
                        remoteSearchViewName: 'virszemes_udens_objekts_riski_gads_distinct_search'
                    }
                }
            }, {
                dataField: 'periods',
                text: 'UBAP periods',
                filterCfg: getSelectFilterCfg(kodif.UO_PERIODS)
            }, {
                dataField: 'biogeni',
                text: 'Biogēni (N, P)',
                filterCfg: getTextFilterCfg()
            }, {
                dataField: 'bistamas',
                text: 'Bīstamās un prioritārās vielas',
                filterCfg: getTextFilterCfg()
            }, {
                dataField: 'hidro',
                text: 'Hidromorfoloģija/bioloģija',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'parrobezu',
                text: 'Pārrobežu',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'pludi',
                text: 'Plūdi',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'cits',
                text: 'Cits',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }]
        }
        
        if(!this.columns){
            this.columns = getColumns({
                kodif: this.props.kodif
            })
        }

        return (
            <div className="saraksts-wrapper">
                <Grid
                    onRowSelected={this.props.virszemesRisksUnIznemumsSelected}
                    loading={this.props.virszemesRiskiUnIznemumiList.loading}
                    selectedId={this.props.virszemesRiskiUnIznemumiList.selected}
                    dataList={this.props.virszemesRiskiUnIznemumiList.list}
                    totalCount={this.props.virszemesRiskiUnIznemumiList.count}
                    columns={this.columns}
                    rowEvents={this.rowEvents}
                />
            </div>
        )
    }
}

const mapStateToProps = ({virszemesRiskiUnIznemumiList, kodif, gui, user}) => {
  return {virszemesRiskiUnIznemumiList, kodif, gui, user}
}

export default connect(mapStateToProps, {virszemesRisksUnIznemumsSelected, guiSet, virszemesRisksUnIznemumsDoubleSelected})(VirszemesRiskiUnIznemumiSaraksts)
